import React from 'react';

export default function HouseRenovation() {
  return (
    <main>
      <div className="heading text-center py-8 bg-gray-100">
        <h3 className="text-4xl font-semibold">House Renovation</h3>
        <p className="text-gray-600">
          {/* adjust link as needed */}
          <a href="/">home</a> / House Renovation
        </p>
      </div>
      {/* Add your House Renovation details here */}
    </main>
  );
}
